<template>
  <div class="startApply">
    <div class="box_wrap">
      <div class="box flex_around">
        <div class="box_item item1">
          <h3 class="title">申请{{title}}</h3>
          <el-form ref="rules" :model="form" :rules="rules">
            <el-form-item prop="company">
              <p class="iptName">公司名称：</p>
              <el-input v-model="form.company"></el-input>
            </el-form-item>
            <el-form-item prop="mobile">
              <p class="iptName">手机号码：</p>
              <el-input v-model="form.mobile"></el-input>
            </el-form-item>
            <el-form-item prop="description">
              <p class="iptName">需求描述：</p>
              <el-input v-model="form.description" type="textarea"></el-input>
            </el-form-item>
            <el-form-item >
              <div class="flex_between">
                <span class="button_return" @click="goBack">返回</span>
                <span class="button_apply" @click="onSubmit('rules')">提交</span>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="box_item item2">
          <h3 class="title">申请流程</h3>
          <div class="applyFlow flexCol_aroud">
            <div class="wrap flex">
              <span class="icon icon1"></span>
              <div class="button_primary">提出服务需求</div>
            </div>
            <div class="wrap flex">
              <span class="icon icon2"></span>
              <div class="button_primary">24小时内客服与您联系</div>
            </div>
            <div class="wrap flex">
              <span class="icon icon3"></span>
              <div class="button_primary">开启项目</div>
            </div>
          </div>
          <div class="button_apply">商务咨询：0571-8861-6565</div>
        </div>
      </div>
    </div>
    <div class="footer"><footBar></footBar></div>
  </div>
</template>

<script>
  import {orders} from "../../api/api"
  import footBar from '../../components/footerbar'
  export default {
    name: "startApply",
    components:{footBar},
    data() {
      return {
        title:'',
        rules: {
          company: [
            {required: true, message: '公司名称不能为空', trigger: 'blur'},
          ],
          mobile: [
            {required: true, message: '手机号码不能为空', trigger: 'blur'},
            {pattern: /^[1][3,4,5,7,8][0-9]{9}$/, message: '手机号码输入有误', trigger: 'blur'}
          ],
          description: [
            {required: true, message: '需求描述不能为空', trigger: 'blur'},
          ],
        },
        form:{
          company:'',
          mobile:'',
          description:'',
        },
      }
    },
    mounted() {
      console.log(this.$route.params);
      this.title  = this.$route.params.title;
    },
    methods: {
      onSubmit(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = {
              company:this.form.company,
              mobile:this.form.mobile,
              product:this.$route.params.product,
              description:this.form.description,
            };
            orders(params).then(res=>{
              if(res.data.code == 1){
                this.$message({
                  message:'我们已收到您的信息，客服会尽快与您联系。',
                  type:'success',
                });
                window.history.go(-1);
              }
            })
          }else{
            console.log('error submit!!');
            return false;
          }
        })
      },
      goBack(){
       window.history.go(-1);
      }
    }
  }
</script>

<style scoped lang="scss">

  .footer{
    height:160px !important;
    position:absolute;
    bottom:0;
    left:0;
    width:100%;
  }
  .startApply {
    /*margin-top: 60px;*/
    height:100vh;
    background:url("../../assets/img/product2/startApplybg.png") 0 0 no-repeat;
    background-size:cover;
    .box_wrap{
      /*width:100%;*/
      /*background:url("../../assets/img/product2/bg.jpg") 0 0 no-repeat;*/
      /*background-size:cover;*/
      /*height:calc(100vh - 240px);*/
    }
    .box{
      width: 1200px;
      height: 550px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -600px;
      margin-top: -323px;
      background: #FFFFFF;
      border: 1px solid #979797;
      border-radius: 5px;
      z-index: 10;
      .box_item{
        padding:30px 50px;
        text-align: left;
        .title{
          font-family: 'pingfang';
          font-size: 24px;
          color: #000000;
          margin-bottom:15px;
        }
        .button_return,.button_apply{
          height:40px;
          line-height: 40px;
          border: 1px solid #D8D8D8;
          border-radius: 3px;
          text-align: center;
          transition:all 0.3s;
          &:hover{
            opacity: 0.9;
            cursor: pointer;
            color:#2F87FF;
            border:1px solid #2F87FF;
            transition:all 0.3s;
          }
        }
        .button_apply{
          background: #2F87FF;
          color:#fff;
          &:hover{
            color:#fff;
          }
        }
      }
      .item1{
        width:70%;
        border-right:1px solid #CAC8C8;
        .iptName{
          font-size: 14px;
          color: #4A4A4A;
        }
        .button_return,.button_apply{
          width:48%;
          height:40px;
          line-height: 40px;
          border: 1px solid #D8D8D8;
          border-radius: 3px;
          text-align: center;
          transition:all 0.3s;
          &:hover{
            opacity: 0.9;
            cursor: pointer;
            color:#2F87FF;
            border:1px solid #2F87FF;
            transition:all 0.3s;
          }
        }
        .button_apply{
          background: #2F87FF;
          color:#fff;
          &:hover{
            color:#fff;
          }
        }
        /deep/ .el-textarea__inner{
          height:130px;
        }
        /deep/ .el-input__inner, /deep/ .el-textarea__inner{
          background: #F7F7F7;
          border: 1px solid #D8D8D8;
          border-radius: 2px;
        }
      }
      .item2{
        width:30%;
        .applyFlow{
          padding:40px 0 90px;
          box-sizing: border-box;
          height:397px;
          .button_primary{
            width:100%;
            margin-left:20px;
            height:60px;
            line-height: 50px;
            box-sizing: border-box;
            padding:0px 10px;
            text-align: left;
            background: url("../../assets/img/product1/steps.png") center center no-repeat;
            background-size:100%;
            border-radius: 5px;
            color:#fff;
            transition:all 0.3s;
            &:hover{
              cursor: pointer;
              opacity: 0.9;
              transition:all 0.3s;
            }
          }
          .icon{
            display: inline-block;
            width:85px;
            height:55px;
          }
          .icon1{
            background:url("../../assets/img/product1/num1.png") center center no-repeat;
            background-size:contain;
          }
          .icon2{
            background:url("../../assets/img/product1/num2.png") center center no-repeat;
            background-size:contain;
          }
          .icon3{
            background:url("../../assets/img/product1/num3.png") center center no-repeat;
            background-size:contain;
          }
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/views/product/startApply.vue